// removed by extract-text-webpack-plugin
module.exports = {"Table":"_3AR6fSsHpSmUE8VpxHuBX0","HeaderCell":"_1jdJZqpAemVXzN_e-BbLR5","HeaderCenter":"AjWUiARcqS1lXwe_DBBbj _1jdJZqpAemVXzN_e-BbLR5","Row":"TzSXSYgV1OhxkMIolHgEw","Active":"_2V9LAN2pqpJq-1YBJ7Pa1t","Cell":"_1v4wDiVYaTlALcj8AoiuJB","CellCenter":"_3cqXtR_IXuWWZrceCuXBim _1v4wDiVYaTlALcj8AoiuJB","ChatInfo":"_1uHE5U_JGhrwsUqwuekWoj","ChatTitle":"_1DZ5GX04vhx0HtBtSD4pFk","SenderName":"_8eUQJqPs1JKIl3A4xkvIy","MessagePreview":"_3ZqZrPtQ8wSwtGY1fU3WRO","AttachmentBadge":"h3L1nf1VRfyCHv8dsxA-c","Empty":"_1Ra2ofuRs7f4ETmh2crRtC"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/ComponentsOfAdministrator/DisputesList/styles.module.css
// module id = 543
// module chunks = 0